(function(){
  function closeMega(except){
    document.querySelectorAll('[data-mega-item].is-open').forEach(function(item){
      if(item !== except){
        item.classList.remove('is-open');
        var btn = item.querySelector('[data-mega-trigger]');
        if(btn){ btn.setAttribute('aria-expanded','false'); }
      }
    });
  }

  document.addEventListener('click', function(event){
    var toggle = event.target.closest('[data-mobile-menu-toggle]');
    if(toggle){
      var menu = document.querySelector('[data-mobile-menu]');
      var isOpen = menu && menu.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      closeMega();
      return;
    }

    var trigger = event.target.closest('[data-mega-trigger]');
    if(trigger && window.matchMedia('(min-width: 991px)').matches){
      var item = trigger.closest('[data-mega-item]');
      if(item){
        var nextState = !item.classList.contains('is-open');
        closeMega(item);
        item.classList.toggle('is-open', nextState);
        trigger.setAttribute('aria-expanded', nextState ? 'true' : 'false');
      }
      return;
    }

    if(!event.target.closest('[data-site-header]')){
      closeMega();
    }
  });

  document.addEventListener('keydown', function(event){
    if(event.key === 'Escape'){
      closeMega();
      var mobileMenu = document.querySelector('[data-mobile-menu]');
      var mobileToggle = document.querySelector('[data-mobile-menu-toggle]');
      if(mobileMenu){ mobileMenu.classList.remove('is-open'); }
      if(mobileToggle){ mobileToggle.setAttribute('aria-expanded','false'); }
    }
  });
})();
